<template>
    <div>
        <h1>Listagem Classes</h1>
        <hr>
        <ul>
            <li>Classes 1</li>
        </ul>
    </div>
</template>

<script>
export default {
    data () {
        return { }
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Wiki/ListagemClasses.vue